// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import AdvancedNavbar from "./layout/EnhancedNavbar";
// import Footer from "./layout/footer";
// import MobileVersionFooter from "./MobileVersionFooter"; // import your mobile footer

// const Layout = ({ children }) => {
//   const location = useLocation();

//   // Define routes where the Navbar should be transparent and overlap
//   const transparentRoutes = [
//     "/",
//     "/sellers",
//     "/Logistics",
//     "/Franchises",
//     "/services",
//     "/franchise",
//     "/business",
//     "/logistics",
//     "/products",
//     "/localsuppliers",
//     "/services/:id",
//     "/business/:id",
//     "/get-to-know",
//   ];
//   const shouldOverlapRoutes = [
//     "/",
//     "/sellers",
//     "/Logistics",
//     "/Franchises",
//     "/services",
//     "/franchise",
//     "/business",
//     "/logistics",
//     "/products",
//     "/localsuppliers",
//     "/services/:id",
//     "/business/:id",
//     "/get-to-know",
//   ];

//   // Define routes where Navbar and Footer should be hidden
//   const hideNavbarRoutes = ["/signup", "/login", "/admin"];
//   const hideFooterRoutes = [
//     "/signup",
//     "/login",
//     "/sellerdashboard",
//     "/userdashboard",
//     "/dashboard/services",
//     "/dashboard/business-services",
//     "/dashboard/franchise",
//     "/logisticsDashboard",
//     "/admin",
//     "/admin/banner-update",
//     "/admin/users-dashboard",
//     "/admin/inquiries",
//     "/admin/products",
//   ];

//   const isTransparent =
//     transparentRoutes.includes(location.pathname) ||
//     location.pathname.startsWith("/services/");
//   const shouldOverlap =
//     shouldOverlapRoutes.includes(location.pathname) ||
//     location.pathname.startsWith("/services/");
//   const hideNavbar = hideNavbarRoutes.includes(location.pathname);
//   const hideFooter = hideFooterRoutes.includes(location.pathname);

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div>
//       {!hideNavbar && (
//         <AdvancedNavbar
//           transparent={isTransparent}
//           shouldOverlap={shouldOverlap}
//         />
//       )}
//       <main
//         style={{
//           paddingTop:
//             shouldOverlap || hideNavbar ? "0" : isMobile ? "60px" : "85px",
//           // Set a default paddingBottom, it will be overridden by footer rendering
//           paddingBottom: hideFooter ? "0" : isMobile ? "80px" : "0px", // Reduced to 80px since no footer on mobile
//           minHeight: isMobile ? "calc(100vh - 60px)" : "auto", // Ensure minimum height for proper scrolling
//         }}
//       >
//         {children}
//       </main>
//       {!hideFooter && (
//         <>
//           {!isMobile && <Footer />}
//           {isMobile && <MobileVersionFooter />}
//         </>
//       )}
//     </div>
//   );
// };

// export default Layout;

import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdvancedNavbar from "./layout/EnhancedNavbar";
import Footer from "./layout/footer";
import MobileVersionFooter from "./MobileVersionFooter";
import axios from "axios";
import { alert } from "../utils/alert";
// Import both tracking systems
import { trackPageVisit, getPageNameFromPath } from "../services/activityTracker";
import { trackPageVisit as trackVisitorVisit, trackInitialVisit } from '../utils/visitorTracker';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Routes where the Navbar should be transparent and overlap
  const transparentRoutes = [
    "/",
    "/sellers",
    "/Logistics",
    "/Franchises",
    "/services",
    "/franchise",
    "/business",
    "/logistics",
    "/products",
    "/localsuppliers",
    "/services/:id",
    "/business/:id",
    "/get-to-know",
  ];
  const shouldOverlapRoutes = [...transparentRoutes];

  // Routes where Navbar and Footer should be hidden
  const hideNavbarRoutes = ["/signup", "/login", "/admin"];
  const hideFooterRoutes = [
    "/signup",
    "/login",
    "/sellerdashboard",
    "/userdashboard",
    // removed dashboard/services & dashboard/logestics so we can handle them separately
    "/dashboard/business-services",
    "/dashboard/franchise",
    "/logisticsDashboard",
    "/admin",
    "/admin/banner-update",
    "/admin/users-dashboard",
    "/admin/inquiries",
    "/admin/products",
  ];

  const isTransparent =
    transparentRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/services/");
  const shouldOverlap =
    shouldOverlapRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/services/");
  const hideNavbar = hideNavbarRoutes.includes(location.pathname);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Track both logged-in users (activityTracker) and anonymous visitors (visitorTracker)
  const hasTrackedInitialVisit = useRef(false);
  const pageStartTime = useRef(Date.now());
  const lastTrackedPathname = useRef(null);

  useEffect(() => {
    // Skip tracking for admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Check if user is logged in
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (isLoggedIn) {
      // Skip if we already tracked this exact pathname (prevents React strict mode duplicates)
      if (lastTrackedPathname.current === location.pathname) {
        return;
      }

      // Track logged-in users using activityTracker (tracks to user-activity/track)
      const pageName = getPageNameFromPath(location.pathname);

      // Only track if pageName is not null (page is in allowed list)
      if (pageName) {
        const url = window.location.href;

        // Calculate duration if this is not the first visit
        let duration = null;
        if (hasTrackedInitialVisit.current && pageStartTime.current) {
          duration = Math.floor((Date.now() - pageStartTime.current) / 1000);
        }

        // Track the page visit
        trackPageVisit(pageName, url, duration);

        // Mark this pathname as tracked
        lastTrackedPathname.current = location.pathname;
      }

      // Update page start time for next page
      pageStartTime.current = Date.now();
      hasTrackedInitialVisit.current = true;
    } else {
      // Track anonymous visitors using visitorTracker (localStorage-based)
      if (!hasTrackedInitialVisit.current) {
        hasTrackedInitialVisit.current = true;
        trackInitialVisit();
      } else {
        trackVisitorVisit(location.pathname, window.location.href);
      }
    }
  }, [location.pathname]);

  // Check verification status on every page load
  useEffect(() => {
    const checkVerificationStatus = async () => {
      // Skip check on login/signup pages or profile/verification pages
      if (location.pathname === "/login" || 
          location.pathname === "/signup" || 
          location.pathname.startsWith("/admin") ||
          location.pathname.includes("/userdashboard") ||
          location.pathname.includes("/profile") ||
          location.search.includes("section=profile")) {
        return;
      }

      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

      if (!isLoggedIn) {
        return;
      }

      // Check if user just clicked "Verify Now" - don't show popup again in this session
      const verifyNowClicked = sessionStorage.getItem("verifyNowClicked");
      if (verifyNowClicked === "true") {
        return;
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/currentuser`, {
          withCredentials: true
        });

        if (response.data && response.data.user) {
          const user = response.data.user;
          const isEmailVerified = user.isEmailVerified === true;
          const isPhoneVerified = user.isPhoneVerified === true;

          // Check if address is filled (not empty string, null, undefined, or empty object)
          let isAddressVerified = false;
          if (user.address) {
            if (typeof user.address === 'string') {
              isAddressVerified = user.address.trim() !== "";
            } else if (typeof user.address === 'object') {
              // Check if address object has at least one non-empty field
              const addressFields = Object.values(user.address);
              isAddressVerified = addressFields.some(field =>
                field && typeof field === 'string' && field.trim() !== ""
              );
            }
          }

          // Show alert if not verified
          if (!isEmailVerified || !isPhoneVerified || !isAddressVerified) {
            // Check if user clicked "Later" recently (within 2 days)
            let shouldShowAlert = true;
            try {
              const dismissedTimestamp = localStorage.getItem('verificationAlertDismissedAt');
              if (dismissedTimestamp) {
                const twoDaysInMs = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
                const timeSinceDismissed = Date.now() - parseInt(dismissedTimestamp);
                shouldShowAlert = timeSinceDismissed >= twoDaysInMs;
              }
            } catch (error) {
              // If localStorage is unavailable (rare), show alert anyway (safe fallback)
              console.warn('localStorage not available, showing verification alert');
            }

            if (shouldShowAlert) {
              alert.verification(
                {
                  isEmailVerified,
                  isPhoneVerified,
                  isAddressVerified
                },
                handleVerifyClick,
                () => { } // onLater - timestamp is already saved in alert.js
              );
            }
          }
        }
      } catch (error) {
        console.error("Error checking verification status:", error);
      }
    };

    checkVerificationStatus();
  }, [location.pathname]);

  // Handle verify button click
  const handleVerifyClick = () => {
    // Mark that user clicked "Verify Now" to prevent popup from showing again
    sessionStorage.setItem("verifyNowClicked", "true");
    // Navigate to userdashboard with Account Settings (profile) section active and refresh
    window.location.href = "/userdashboard?section=profile";
  };

  // ✅ Footer logic
  const renderFooter = () => {

    if (
      location.pathname === "/dashboard/services" ||
      location.pathname === "/logisticsDashboard" ||
      location.pathname === "/sellerdashboard" ||
      location.pathname === "/dashboard/business-services" ||
      location.pathname === "/dashboard/franchise"
    ) {
      return null; // Hide footer on both mobile and desktop for dashboards
    }

    if (hideFooterRoutes.includes(location.pathname)) {
      return null;
    }

    return isMobile ? <MobileVersionFooter /> : <Footer />;
  };

  return (
    <div>
      {!hideNavbar && (
        <AdvancedNavbar
          transparent={isTransparent}
          shouldOverlap={shouldOverlap}
        />
      )}
      <main
        style={{
          paddingTop:
            shouldOverlap || hideNavbar ? "0" : isMobile ? "60px" : "85px",
          paddingBottom:
            location.pathname === "/dashboard/services" ||
              location.pathname === "/logisticsDashboard" || location.pathname === "/sellerdashboard" ||
              location.pathname === "/dashboard/business-services" ||
              location.pathname === "/dashboard/franchise"
              ? "0" // No padding for dashboards on both mobile and desktop
              : hideFooterRoutes.includes(location.pathname)
                ? "0"
                : isMobile
                  ? "80px"
                  : "0px",
          minHeight: isMobile ? "calc(100vh - 60px)" : "auto",
        }}
      >
        {children}
      </main>
      {!hideNavbar && renderFooter()}
    </div>
  );
};

export default Layout;
